import type { GemxQlQueryResponse, GemxQlQueryVariables } from '~/core/gemxql/graphql';
import type { BaseHeaderResponse } from '~/api/types/graphqlClient';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { IReportType } from '../types/report';

import { GemxQlDocument } from '~/core/gemxql/graphql';
import { useQuery } from '@tanstack/react-query';
import { appFetcherCustom } from '~/api/utils';

export interface CustomReportResponse extends GemxQlQueryResponse {
  gemxQLQuery: IReportType;
  headers: BaseHeaderResponse;
}

export const useCustomReportQuery = <TData = CustomReportResponse, TError = unknown>(
  variables: GemxQlQueryVariables,
  options?: UseQueryOptions<CustomReportResponse, TError, TData>,
) => {
  return useQuery<CustomReportResponse, TError, TData>(
    ['ReportCustom', variables],
    appFetcherCustom<CustomReportResponse, GemxQlQueryVariables>(GemxQlDocument, variables),
    options,
  );
};

useCustomReportQuery.getKey = (variables: GemxQlQueryVariables) => ['ReportCustom', variables];
